import createIcon from '../../createIcon';

/**
 * @component @name Plumbing
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkuMjc4OCA0LjkyOTYxTDE3LjE1ODggMi44MDk2MUMxNi4zNzg4IDIuMDI5NjEgMTUuMTA4OCAyLjAyOTYxIDE0LjMyODggMi44MDk2MUwxMS40OTg4IDUuNjM5NjFMMTMuNjE4NyA3Ljc1OTYxTDE1LjczODggNS42Mzk2MUwxOS4yNzg4IDkuMTc5NjFDMjAuNDQ4OCA3Ljk5OTYxIDIwLjQ0ODggNi4wOTk2MSAxOS4yNzg4IDQuOTI5NjFaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNNS40ODg3NSAxMy43Njk2QzYuMDc4NzUgMTQuMzU5NiA3LjAyODc1IDE0LjM1OTYgNy42MDg3NSAxMy43Njk2TDEwLjA3ODggMTEuMjk5Nkw3Ljk1ODc1IDkuMTY5NjFMNS40ODg3NSAxMS42Mzk2QzQuODk4NzUgMTIuMjI5NiA0Ljg5ODc1IDEzLjE3OTYgNS40ODg3NSAxMy43Njk2WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTE1LjAzODcgNy43NTk2MUwxMy42MTg3IDkuMTc5NjFMMTAuNDM4NyA1Ljk5OTYxQzkuODQ4NzUgNS4zOTk2MSA4Ljg5ODc1IDUuMzk5NjEgOC4zMTg3NSA1Ljk4OTYxQzcuNzI4NzUgNi41Nzk2MSA3LjcyODc1IDcuNTI5NjEgOC4zMTg3NSA4LjEwOTYxTDExLjQ5ODggMTEuMjg5Nkw0LjQyODc1IDE4LjM1OTZDMy42NDg3NSAxOS4xMzk2IDMuNjQ4NzUgMjAuNDA5NiA0LjQyODc1IDIxLjE4OTZDNS4yMDg3NSAyMS45Njk2IDYuNDc4NzUgMjEuOTY5NiA3LjI1ODc1IDIxLjE4OTZMMTYuNDQ4OCAxMS45OTk2QzE2LjgzODggMTIuMzg5NiAxNy40Njg4IDEyLjM4OTYgMTcuODU4OCAxMS45OTk2QzE4LjI0ODggMTEuNjA5NiAxOC4yNDg4IDEwLjk3OTYgMTcuODU4OCAxMC41ODk2TDE1LjAzODcgNy43NTk2MVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Plumbing = createIcon('Plumbing', [
  [
    'path',
    {
      d: 'M19.2788 4.92961L17.1588 2.80961C16.3788 2.02961 15.1088 2.02961 14.3288 2.80961L11.4988 5.63961L13.6187 7.75961L15.7388 5.63961L19.2788 9.17961C20.4488 7.99961 20.4488 6.09961 19.2788 4.92961Z',
      key: '96syyf',
    },
  ],
  [
    'path',
    {
      d: 'M5.48875 13.7696C6.07875 14.3596 7.02875 14.3596 7.60875 13.7696L10.0788 11.2996L7.95875 9.16961L5.48875 11.6396C4.89875 12.2296 4.89875 13.1796 5.48875 13.7696Z',
      key: '1kexn2',
    },
  ],
  [
    'path',
    {
      d: 'M15.0387 7.75961L13.6187 9.17961L10.4387 5.99961C9.84875 5.39961 8.89875 5.39961 8.31875 5.98961C7.72875 6.57961 7.72875 7.52961 8.31875 8.10961L11.4988 11.2896L4.42875 18.3596C3.64875 19.1396 3.64875 20.4096 4.42875 21.1896C5.20875 21.9696 6.47875 21.9696 7.25875 21.1896L16.4488 11.9996C16.8388 12.3896 17.4688 12.3896 17.8588 11.9996C18.2488 11.6096 18.2488 10.9796 17.8588 10.5896L15.0387 7.75961Z',
      key: '1xk3az',
    },
  ],
]);

export default Plumbing;
